import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import sr from './locales/sr.json';
import en from './locales/en.json';

i18n?.use(LanguageDetector)?.use(initReactI18next)?.init({
    resources: {
      sr: { translation: sr },
      en: { translation: en },
    },
    lng: 'en',
    fallbackLng: 'en',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'valuebook_language',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
